import { ChevronDown, ShieldAlert } from 'lucide-react';
import HighlightedText from '../../common/HighlightedText';

const FaqAccordion = ({ filteredFaqs, openFaqId, toggleFaq, keyword }) => {
    return (
        <div className="bg-white border border-gray-100 rounded-3xl shadow-sm overflow-hidden">
            {filteredFaqs.length === 0 ? (
                <div className="text-center py-20 flex flex-col items-center justify-center">
                    <ShieldAlert size={40} className="text-gray-300 mb-4" />
                    <p className="text-gray-400 font-medium">검색 결과가 없습니다.</p>
                </div>
            ) : (
                <div className="divide-y divide-gray-100">
                    {filteredFaqs.map((faq) => {
                        const isOpen = openFaqId === faq.id;

                        return (
                            <div key={faq.id} className="transition-all duration-200">
                                <button
                                    onClick={() => toggleFaq(faq.id)}
                                    className={`w-full text-left px-6 py-5 flex items-center justify-between gap-4 hover:bg-[#f8fafc] transition-colors ${isOpen ? 'bg-[#f8fafc]' : ''}`}
                                >
                                    <div className="flex items-center gap-4 flex-1">
                                        <div className={`flex-shrink-0 w-1 h-1 rounded-full flex items-center justify-center font-bold text-sm transition-colors ${isOpen ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-600'}`}>
                                            Q
                                        </div>
                                        <div>
                                            <span className={`font-bold text-base ${isOpen ? 'text-blue-700' : 'text-gray-800'}`}>
                                                <HighlightedText text={faq.title || faq.question} highlight={keyword} />
                                            </span>
                                        </div>
                                    </div>
                                    <ChevronDown
                                        size={20}
                                        className={`text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180 text-blue-500' : ''}`}
                                    />
                                </button>

                                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                                    <div className="p-6 pt-2 pb-6 bg-[#f8fafc] flex gap-4 border-l-2 border-blue-500 ml-6 mr-6 mb-4 rounded-r-2xl">
                                        <div className="flex-shrink-0 w-1 h-1 bg-gray-800 rounded-full flex items-center justify-center font-bold text-white text-sm">
                                            A
                                        </div>
                                        <div className="flex-1">
                                            {faq.question && (
                                                <div className="mb-3 pb-3 border-b border-gray-200">
                                                    <p className="text-sm font-semibold text-gray-700 leading-relaxed">
                                                        질문: <HighlightedText text={faq.question} highlight={keyword} />
                                                    </p>
                                                </div>
                                            )}
                                            <div
                                                className="text-sm leading-relaxed text-gray-600 pt-1 whitespace-pre-wrap"
                                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FaqAccordion;
